import React, {useState, useEffect, useRef, useCallback} from 'react';
import {
    Link,
    useHistory
} from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { yourInfoAdded, yourInformationSelector } from '../../../../store/reducers/yourInfoReducer';
import { primaryContractAdded } from '../../../../store/reducers/primConReducer';
import { pathAdded } from '../../../../store/reducers/pathsReducer';
import { classAddedMobile, scrollMobileSelector } from '../../../../store/reducers/scrollMobileReducer';
import { useForm } from "react-hook-form";
import ErrorMessage from "./error/ErrorMessage";
import Tooltip from '../../../registered/tooltip/Tooltip';
import Select from 'react-select';
import { promoCodeSelector } from '../../../../store/reducers/promoCodeReducer';
import {emailValidationRegex, nameValidationRegex, emailValidationRegexAllowPersonal} from "../../../../constants";
import { registrationSettingsSelector } from '../../../../store/reducers/registrationSettingsReducer'; 

function YourInformation({ countryCodeArr }) {
    const promoCode = useSelector(promoCodeSelector);
    const dispatch = useDispatch();
    const yourInfo = useSelector(yourInformationSelector);
    const registrationData = useSelector(registrationSettingsSelector);
    const scroll = useSelector(scrollMobileSelector);
    let history = useHistory();
    const [emailValidation, setEmailValidation] = useState(emailValidationRegex);
    const [scrollClass, setScrollClass] = useState(scroll);
    const [countryCode, setCountryCode] = useState(yourInfo.countryCode);
    const [methodValue, setMethodValue] = useState(false);
    const [openTooltip, setOpenTooltip] = useState(false);
    const [tooltipClass, setTooltipClass] = useState("more_info-closed small");
    const [openEmail, setOpenEmail] = useState(false);
    const [openPrim, setOpenPrim] = useState(false);
    const [tooltipClassPrim, setTooltipClassPrim] = useState("more_info-inline small");
    const [tooltipClassEmail, setTooltipClassEmail] = useState("more_info-inline small");
    const [radioChecked, setRadioChecked] = useState(true);
    const [selectClass, setSelectClass] = useState("react-select");
    const { register, handleSubmit, formState: { errors }} = useForm();
    const span = useRef();
    const span1 = useRef();
    const span2 = useRef();
    const filteredArray = countryCodeArr.filter(code => { return code.value === yourInfo.countryCode})

    const handleClickTooltip = useCallback(e => {
        if(span1?.current?.contains(e.target)) {
            setOpenPrim(true);
            setTooltipClassPrim("more_info-inline small active");
            setTooltipClassEmail("more_info-inline small");
            setOpenEmail(false);
            return;
        } else if(span2?.current?.contains(e.target)) {
            setOpenEmail(true);
            setTooltipClassEmail("more_info-inline small active");
            setOpenPrim(false);
            setTooltipClassPrim("more_info-inline small");
            return;
        }   
        setTooltipClassPrim("more_info-inline small");
        setTooltipClassEmail("more_info-inline small");
        setOpenPrim(false);
        setOpenEmail(false);   
  }, [span1, span2, setOpenPrim, setTooltipClassEmail, setTooltipClassPrim, setOpenEmail]);

    useEffect(() => {
        if(countryCode !== undefined) {
            setMethodValue(true)
        };
        if(promoCode.isHuri === true) {
            setEmailValidation(emailValidationRegexAllowPersonal);
        }
        window.scrollTo(0, 0);

        document.addEventListener("mousedown", handleClick);
        return () => {
            document.removeEventListener("mousedown", handleClick);
        };
      }, []); // eslint-disable-line
    useEffect(() => {
        setTimeout(function(){ setScrollClass("progression_container small") ; }, 10);
        document.addEventListener("mousedown", handleClickTooltip);
        return () => {
            document.removeEventListener("mousedown", handleClickTooltip);
        };
    }, []); // eslint-disable-line

    const handleClick = e => {
        if (span.current.contains(e.target)) {
            setOpenTooltip(true)
            setTooltipClass("more_info-active small")
            return;
        }
        setOpenTooltip(false)
        setTooltipClass("more_info-closed small")        
    };

    function onSubmit(data, event) {
        if(methodValue) {    
            data = {
                firstName: data.firstName,
                lastName: data.lastName,
                countryCode: countryCode,
                mobileNum: data.mobileNum,
                email: data.email,
                primary: data.primary
            }
            const data_prim = {
                firstName: data.firstName,
                lastName: data.lastName,
                countryCode: countryCode,
                mobileNum: data.mobileNum,
                email: data.email,
            };
            if(data.primary === "yes") {
                dispatch(yourInfoAdded(data));
                dispatch(primaryContractAdded(data_prim));
                dispatch(pathAdded(history.location.pathname));
                dispatch(classAddedMobile("progression_container small startBottom"));
                history.push("/form/primary");
            } else {
                dispatch(yourInfoAdded(data));
                dispatch(pathAdded(history.location.pathname));
                dispatch(classAddedMobile("progression_container small startBottom"));
                history.push("/form/primary");

            }
        }
    };

    function switchRadioNo(e) {
        setRadioChecked(false);
    };

    function switchRadioYes(e) {
        setRadioChecked(true);
    };

    function setMethod(e) {
        setMethodValue(true);
        setCountryCode(e.value);
    };

    function handleSelectClass() {
        setSelectClass("select-error")
    };

    function setClass() {
        dispatch(classAddedMobile("progression_container small startTop"));
    };

    return (
        <div className={scrollClass}>
            <h2>Your information
                <span 
                    className={tooltipClass} 
                    ref={span}
                    onClick={handleClick}>                  
                        {openTooltip && (
                            <Tooltip title="" text={registrationData.your_info_description}/>
                        )}
                </span>
            </h2>
            
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className="form-group">
                    <label htmlFor="firstName">First name</label>
                    <input 
                        type="text" 
                        defaultValue={yourInfo.firstName}                       
                        className={errors.firstName ? "errorInput" : ""} 
                        name="firstName" placeholder="Enter your first name" 
                        {...register("firstName", { 
                            required: "First name is required",
                            minLength: {
                                value: 2,
                                message: "Must be longer than 2 letters"
                            },
                            pattern: {
                                value: nameValidationRegex,
                                message: "Cannot contain numbers or special characters"
                            } 
                        })} 
                    />
                    {errors.firstName && <ErrorMessage>{errors.firstName.message}</ErrorMessage>} 
                </div>

                <div className="form-group">
                    <label htmlFor="lastName">Last name</label>
                    <input 
                        type="text" 
                        defaultValue={yourInfo.lastName}        
                        className={errors.lastName ? "errorInput" : ""} 
                        name="lastName" placeholder="Enter your last name" 
                        {...register("lastName", { 
                            required: "Last name is required",
                            minLength: {
                                value: 2,
                                message: "Must be longer than 2 letters"
                            },
                            pattern: {
                                value: nameValidationRegex,
                                message: "Cannot contain numbers or special characters"
                            } 
                        })} 
                    />
                    {errors.lastName && <ErrorMessage>{errors.lastName.message}</ErrorMessage>}
                </div>

                <div className="form-group_container">
                    <div className="form-group form-countryCode">
                        <label htmlFor="countryCode">Country code</label>
                        <Select 
                            className={methodValue === false && selectClass}   
                            name="countryCode" 
                            defaultValue={yourInfo.countryCode !== undefined ? {label: filteredArray[0].label, value: yourInfo.countryCode } : {label: " - ", value: "" } }
                            options={countryCodeArr} 
                            searchable={false}
                            onChange={setMethod}
                            classNamePrefix="react-select"
                        />
                        {(selectClass === "select-error") && (methodValue === false) && <ErrorMessage>Please select a country code</ErrorMessage>}
                    </div>

                    <div className="form-group form-mobile">
                        <label htmlFor="mobileNum">Mobile number</label>
                        <input 
                            type="text" 
                            defaultValue={yourInfo.mobileNum}
                            className={errors.mobileNum ? "errorInput" : ""} 
                            name="mobileNum" placeholder="Enter your number" 
                            {...register("mobileNum", { 
                                required: "Mobile number is required",
                                pattern: {
                                    value: /^([0-9]){4,12}$/,
                                    message: "invalid phone number. Example (12345678)"
                                }
                            })} 
                        />
                        {errors.mobileNum && <ErrorMessage>{errors.mobileNum.message}</ErrorMessage>}
                    </div>
                </div>

                <div className="form-group">
                    <label className="email" htmlFor="email">E-mail
                        <span 
                            className={tooltipClassEmail} 
                            ref={span2}
                            onClick={handleClickTooltip}>                  
                                {openEmail && (
                                    <Tooltip title="" text={registrationData.your_info_email_information}/>
                                )}
                        </span>
                    </label>
                    <input 
                        type="text" 
                        className={errors.email ? "errorInput" : ""} 
                        name="email" 
                        defaultValue={yourInfo.email}
                        placeholder="Enter your email" 
                        {...register("email", { 
                            required: "Email is required",
                            pattern: {
                                value: emailValidation,
                                message: "Invalid email address. Example: (yourname@yourcompany.no)"
                            }})
                        } 
                    />
                    {errors.email && <ErrorMessage>{errors.email.message}</ErrorMessage>}
                </div>

                <div className="radio-group">  
                    <p className="primary_contract">Are you the primary contract administrator?
                        <span 
                            className={tooltipClassPrim} 
                            ref={span1}
                            onClick={handleClick}>                  
                                {openPrim && (
                                    <Tooltip title="" text={registrationData.your_info_primary_info}/>
                                )}
                        </span>    
                        </p>  
                    {(yourInfo.primary === undefined) || (yourInfo.primary === "yes") 
                        ?
                            <>
                                <label className="container">
                                    <input 
                                        type="radio" 
                                        value="yes" 
                                        name="primary" 
                                        onClick={switchRadioYes} 
                                        checked={radioChecked} 
                                        {...register("primary", { required: "Please select an option" })}
                                    />
                                    <span className="checkmark"></span> Yes
                                </label>
                                <label className="container">
                                <input 
                                    type="radio" 
                                    value="no" 
                                    name="primary" 
                                    onClick={switchRadioNo} 
                                    {...register("primary", { required: "Please select an option" })}
                                />
                                    <span className="checkmark"></span> No
                                </label>
                            </>
                        : 
                            <>
                                <label className="container">
                                    <input 
                                        type="radio" 
                                        value="yes" 
                                        name="primary" 
                                        onClick={switchRadioNo} 
                                        
                                        {...register("primary", { required: "Please select an option" })}
                                    />
                                    <span className="checkmark"></span> Yes
                                </label>
                                <label className="container">
                                <input 
                                    type="radio" 
                                    value="no" 
                                    name="primary" 
                                    onClick={switchRadioYes} 
                                    checked={radioChecked} 
                                    {...register("primary", { required: "Please select an option" })}
                                />
                                    <span className="checkmark"></span> No
                                </label>
                            </>
                    }
                    {errors.primary && <ErrorMessage>{errors.primary.message}</ErrorMessage>}
                </div>

                <div className="button_container">
                    <Link to={`/form`} onClick={setClass} className="previous"><span>
                        <svg width="13" height="11" viewBox="0 0 13 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M10.0815 6.5201L8.27352 8.3281L7.52152 9.0961C6.92952 9.6881 6.30552 10.3121 5.64952 11.0001H7.77752C8.92952 9.8001 11.3615 7.1441 12.7215 5.7841C11.3775 4.4401 8.94552 1.8001 7.77752 0.600098H5.64952C6.30552 1.2881 6.92952 1.9121 7.52152 2.5041L8.27352 3.2721L8.99352 4.0081C9.45752 4.4561 9.84152 4.8721 10.0815 5.0801H0.561523V6.5201H10.0815Z" fill="white"></path>
                        </svg>
                    </span> Previous</Link>                
                    
                    <button onClick={handleSelectClass} className="nextSubmit next" type="submit">
                        <span>Next</span>
                        <svg width="13" height="11" viewBox="0 0 13 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M10.0815 6.5201L8.27352 8.3281L7.52152 9.0961C6.92952 9.6881 6.30552 10.3121 5.64952 11.0001H7.77752C8.92952 9.8001 11.3615 7.1441 12.7215 5.7841C11.3775 4.4401 8.94552 1.8001 7.77752 0.600098H5.64952C6.30552 1.2881 6.92952 1.9121 7.52152 2.5041L8.27352 3.2721L8.99352 4.0081C9.45752 4.4561 9.84152 4.8721 10.0815 5.0801H0.561523V6.5201H10.0815Z" fill="white"></path>
                        </svg>
                    </button>
                </div>
            </form>
        </div>
    );
}

export default YourInformation;
